module.exports = "mat-option {\n  height: 36px; }\n\n::ng-deep mat-option .mat-option-text {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 12px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/form-fields/autocomplete-address-field/autocomplete-address-field.component.scss
// module id = ./src/app/components/form-fields/autocomplete-address-field/autocomplete-address-field.component.scss
// module chunks = main